import IconClose from '@assets/images/common/icon/close.svg';
import React from 'react';

interface ThreadHeaderProps {
  channelName: string;
  onClose: () => void;
  className?: string;
}

const ThreadHeader: React.FC<ThreadHeaderProps> = ({ onClose, className = '', channelName }) => {
  return (
    <div
      className={`flex h-[42px] items-center justify-between border-b border-gray-200 bg-white pl-[21px] pr-[19px] sm:h-[60px] ${className}`}
    >
      <div className='flex flex-col gap-1'>
        <h1 className='text-lg font-bold text-gray-900 lg:text-base'>スレッド</h1>
        <p className='hidden text-xs text-[#555555] sm:block'>{channelName}</p>
      </div>

      <button
        type='button'
        onClick={onClose}
        className='flex size-6 shrink-0 items-center justify-center rounded hover:bg-gray-100'
        aria-label='スレッドを閉じる'
      >
        <img
          src={IconClose}
          alt='閉じる'
          className='size-5'
        />
      </button>
    </div>
  );
};

export default ThreadHeader;
